// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1As6U","name":"Header_name__66wnS","birthday":"Header_birthday__3nvB4","skeleton":"Header_skeleton__1AWrX"};